import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBlog, updateBlog } from "./blogAPI";

// initial state
const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (blogId) => {
  const blog = await getBlog(blogId);
  return blog;
});

export const updateBlogAsync = createAsyncThunk(
  "blog/updateBlog",
  async ({ blogId, updateValue }) => {
    const blog = await updateBlog(blogId, updateValue);
    return blog;
  }
);

// create slice
const blogSlice = createSlice({
  name: "blog",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlog.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blog = action.payload;
      })
      .addCase(fetchBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.blog = {};
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(updateBlogAsync.fulfilled, (state, action) => {
        console.log(action);
        state.blog = action.payload;
      });
  },
});

export default blogSlice.reducer;
